//replaces defaultHeader.html
import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";

interface IDefaultHeaderTemplate {
    row: any;
}
export const DefaultHeaderTemplateV2: FC<IDefaultHeaderTemplate> = (props) => {
    const { row } = props;

    return <div>{i18nFilter()(row.displayName)}</div>;
};
